export default "__VITE_PUBLIC_ASSET__21b2576e__"